module.exports = __webpack_public_path__ + "img/8_en.c5eeb37f.png";